<template>
    <p-dialog v-model:visible="open" modal closable header=" " class="border-none rounded-none !min-h-[60vh] !min-w-[35vw]"
        :append-to="getModalContainer()">
        <template #closeicon>
            <span class="pi pi-times" :style="{ color: colors.primary }"></span>
        </template>
        <content-block v-if="getSetting('email_to_book_form')" :id="getSetting('email_to_book_form')" />
    </p-dialog>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { Dialog as PDialog } from "primevue";
import { router } from "@inertiajs/vue3";
import { getModalContainer, whenJQuery } from "@/utils/helpers";
import useTheme from "@/Hook/useTheme";
import ContentBlock from "./ContentBlock.vue";
import { useSetting } from "@/Hook/useSetting";

const open = ref(false);

const { colors } = useTheme();

const { getSetting } = useSetting()

onMounted(function () {
    // router.on() registers a document-level listener, so it must run in the
    // browser (onMounted), not during setup/SSR.
    router.on('before', function () {
        open.value = false;
    });

    whenJQuery(function () {
        jQuery(document).on("click", ".email_to_book", function () {
            open.value = true;
        });
    });
});
</script>
